// extracted by mini-css-extract-plugin
export default {"resetPasswordLogo":"ResetPage_resetPasswordLogo__v8KDz"};